import { getDictPhrase } from "../../../common";
import { getTaxDeductAmount, getBetRulesMessages } from "../../bet";
export const getTotalReturnProps = (bet, state) => {
    let riskFreeBetAmount = bet.isRiskFreeBet ? bet.freeBetAmount : 0, comboBonusAmount = bet.comboBonusWinningsAmount ? bet.comboBonusWinningsAmount : 0, taxReduceAmount = getTaxDeductAmount(bet);
    riskFreeBetAmount = riskFreeBetAmount ? riskFreeBetAmount : 0;
    const totalReturn = Math.max(bet.returns + riskFreeBetAmount + comboBonusAmount - taxReduceAmount, 0);
    const ruleMesaages = getBetRulesMessages(bet, state);
    return {
        phrase: `${getDictPhrase(state.dict, "TotalReturn")}${ruleMesaages}`,
        amount: state.formatCurrency(totalReturn)
    };
};
//# sourceMappingURL=getTotalReturnProps.js.map